const renameProperty = (oldProp, newProp, { [oldProp]: old, ...others }) => {
  return {
    [newProp]: old,
    ...others,
  };
};

const searchField = (property, contactColumns) => {
  return contactColumns.filter((column) => column.database == property);
};

const getters = {
  contactFiltered(state, getters) {
    let contact = { ...state.contact };

    Object.keys(contact).map((property) => {
      const [column] = searchField(property, getters.contactColumnsOrderDesc);
      // const labelField = state.fieldsLabels[property]
      if (column && column.show == 'Y') {
        contact = renameProperty(property, column.desc, contact);
      } else {
        delete contact[property];
      }
    });

    return contact;
  },
  contactColumnsOrderDesc(state) {
    let contactColumns = [...state.contactColumns];
    return contactColumns.sort((a, b) => a.order - b.order);
  },

  getContactsFound(state) {
    return (protocol) => state.contactsFound[protocol];
  },

  getContactInformation(state) {
    const { data } = state.contact || {};
    if (!Array.isArray(data)) return null;

    return state.contact.data[0];
  },

  getHistoryFromContact(state) {
    const { data } = state.historyFromContact || {};
    return Array.isArray(data) ? null : data || null;
  },
};

export default getters;
